var reactIs = { exports: {} };
export {
  reactIs as __module
};
//# sourceMappingURL=index.js.map
